import { render, staticRenderFns } from "./BulkSetupStatementDialog.vue?vue&type=template&id=0f0c6c1c&"
import script from "./BulkSetupStatementDialog.vue?vue&type=script&lang=js&"
export * from "./BulkSetupStatementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports